import React from "react";
import { useNavigate } from "react-router-dom";
import { CompanySelection } from "@x-veloper/dataslot-auth";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Alert, AlertDescription } from "../components/ui/alert";

/**
 * Company Selection Page for MasterLabel Commission
 * Uses the shared CompanySelection component from @repo/firebase-auth
 */
export default function SelectCompany() {
  const navigate = useNavigate();

  const handleCompanySelect = () => {
    // Redirect to dashboard after company selection
    navigate("/");
  };

  return (
    <CompanySelection
      components={{
        Card,
        CardContent,
        CardHeader,
        CardTitle,
        Button,
        Badge,
        Alert,
        AlertDescription,
      }}
      onCompanySelect={handleCompanySelect}
    />
  );
}